import { render, staticRenderFns } from "./ProductSkuAutocompleteBasic.vue?vue&type=template&id=3f288698"
import script from "./ProductSkuAutocompleteBasic.vue?vue&type=script&lang=ts"
export * from "./ProductSkuAutocompleteBasic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports